(function () {
  const initKitSliders = () => {
    if (typeof Swiper === 'undefined') return;

    const wrappers = document.querySelectorAll('[data-kit-slider]');

    wrappers.forEach(wrapper => {
      const swiperEl = wrapper.querySelector('.kit-slider__inner');
      const nextEl = wrapper.querySelector('.swiper-button-next');
      const prevEl = wrapper.querySelector('.swiper-button-prev');

      if (!swiperEl || swiperEl.kitSwiperInitialized) return;

      swiperEl.kitSwiperInitialized = true;

      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        navigation: {
          nextEl,
          prevEl
        },
        watchOverflow: true,
        breakpoints: {
          768: { spaceBetween: 14 },
          1100: { spaceBetween: 10 }
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initKitSliders);
  document.addEventListener('shopify:section:load', initKitSliders);
})();
